export default "__VITE_ASSET__e34f7542__"